import { formatMoney } from 'src/utils/common';

export const formatFinalValue = (valor, cupom) => {
  const value_cupom = cupom ? cupom.valor / 100 : 0;
  const final_value = valor - value_cupom;

  return formatMoney(final_value < 0 ? 0 : final_value);
};
